import { render, staticRenderFns } from "./Relatorios.vue?vue&type=template&id=61bd4dc6&scoped=true&"
import script from "./Relatorios.vue?vue&type=script&lang=js&"
export * from "./Relatorios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bd4dc6",
  null
  
)

export default component.exports